import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-block confirm-details" }
const _hoisted_2 = { class: "label-block mb-0" }
const _hoisted_3 = { class: "d-flex w-100 align-items-start switch-container switch-container-v2 flex-nowrap flex-row" }
const _hoisted_4 = { class: "label-block_label mb-0" }
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = { class: "switch-toggle switch-toggle-v2 mt-0" }
const _hoisted_7 = {
  for: "yesNo",
  class: "mb-0"
}
const _hoisted_8 = ["data-checked", "data-unchecked"]
const _hoisted_9 = {
  key: 0,
  class: "label-block_question position-relative"
}
const _hoisted_10 = { class: "tooltip-content" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  class: "popper",
  "data-bs-trigger": "hover",
  placement: "right",
  "data-bs-toggle": "popover"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon-question-icon" })
  ])
], -1)

import { store } from "@/store";
import {
  computed,
  defineComponent,
  toRef,
  ref,
  watch,
  onMounted
} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'enInputCheckBox',
  props: {
  isRequired: {
    type: Boolean,
    required: false,
    default: false,
  },
  label: {
    type: String,
    required: true,
    default: "",
  },
  modelValue: {
    type: Boolean,
    required: true,
    default: false,
  },
  tooltipMessage: {
    type: String,
    required: false,
    default: "",
  },
  isTooltip: {
    type: Boolean,
    required: false,
    default: false,
  },
  formProp: {
    type: String,
    required: false,
    default: "",
  },
},
  emits: ["setValue", "update:modelValue"],
  setup(__props, { emit: __emit }) {

/* eslint-disable */
const props = __props;

const emit = __emit;
const myValue = toRef(props, "modelValue");
const defValue = ref<boolean>(false);

onMounted(() => {
  defValue.value = myValue.value;
});

watch(myValue, (newValue) => {
  defValue.value = newValue;
});

const changeValue = () => {
  emit("update:modelValue", defValue.value);
  emit("setValue");
};

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form_item, { prop: __props.formProp }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, _toDisplayString(__props.label), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                id: "yesNo",
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((defValue).value = $event)),
                onChange: changeValue
              }, null, 544), [
                [_vModelCheckbox, defValue.value]
              ]),
              _createElementVNode("label", _hoisted_7, [
                _createElementVNode("div", {
                  class: "switch-toggle__switch",
                  "data-checked": _ctx.$t('yes'),
                  "data-unchecked": _ctx.$t('no')
                }, null, 8, _hoisted_8)
              ])
            ]),
            (__props.isTooltip)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_el_tooltip, {
                    class: "box-item",
                    effect: "light"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("p", _hoisted_10, _toDisplayString(__props.tooltipMessage), 1)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["prop"])
    ])
  ]))
}
}

})